// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as LoadingViewComponent$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";

function RnrLoading(Props) {
  var content = Props.content;
  return React.createElement("div", undefined, React.createElement(LoadingViewComponent$Catalyst.make, {
                  text: content.status.loading
                }));
}

var make = RnrLoading;

export {
  make ,
  
}
/* react Not a pure module */
